import type { BackendTypes } from '@tf/api';

export const getAvailableStatuses = ({
	status,
	verificationStatus,
}: {
	status: BackendTypes.OverviewAccountStatus | 'UNDEFINED';
	verificationStatus?: BackendTypes.ReviewState;
}) => {
	const result: BackendTypes.OverviewAccountStatus[] = [];

	const addGoToActiveIfAvailable = () => {
		if (verificationStatus === 'VERIFIED' || verificationStatus === 'UPDATE_REQUIRED') {
			result.push('ACTIVE');
		}
	};

	switch (status) {
		case 'UNDEFINED': {
			result.push('PROSPECT');
			break;
		}
		case 'PROSPECT': {
			addGoToActiveIfAvailable();
			result.push('REJECTED');
			break;
		}
		case 'REJECTED': {
			result.push('PROSPECT');
			break;
		}
		case 'ACTIVE': {
			result.push('SUSPENDED', 'CLOSED');
			break;
		}
		case 'SUSPENDED': {
			addGoToActiveIfAvailable();
			result.push('CLOSED');
			break;
		}
		case 'CLOSED': {
			// Can go back to active/suspended - because from these to it's possible to get to Closed
			addGoToActiveIfAvailable();
			result.push('SUSPENDED');
			break;
		}
		case 'ARCHIVED': {
			// Can go back to any status
			result.push('PROSPECT');
			addGoToActiveIfAvailable();
			result.push('SUSPENDED', 'REJECTED', 'CLOSED');
			break;
		}
	}

	if (status !== 'ARCHIVED') {
		result.push('ARCHIVED');
	}

	return result;
};
